import _extends from "@babel/runtime/helpers/esm/extends";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
// Utils
import { createNamespace, isDef } from '../utils';
import { emit, inherit } from '../utils/functional';
import { routeProps, functionalRoute } from '../utils/router';
import { cellProps } from './shared'; // Components

import Icon from '../icon'; // Types

var _createNamespace = createNamespace('cell'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

function Cell(h, props, slots, ctx) {
  var icon = props.icon,
      size = props.size,
      title = props.title,
      label = props.label,
      value = props.value,
      isLink = props.isLink,
      isLinkTitle = props.isLinkTitle,
      isValueLeft = props.isValueLeft,
      bigIcon = props.bigIcon;
  var showTitle = slots.title || isDef(title);
  var linkTitleCls = isLinkTitle ? 'linkTitle' : '';

  function Label() {
    var showLabel = slots.label || isDef(label);

    if (showLabel) {
      return h("div", {
        "class": [bem('label'), props.labelClass]
      }, [slots.label ? slots.label() : label]);
    }
  }

  function Title() {
    if (showTitle) {
      var left = isValueLeft ? 'title-auto' : bem('title');
      return h("div", {
        "class": [left, props.titleClass],
        "style": props.titleStyle
      }, [slots.title ? slots.title() : h("span", {
        "class": linkTitleCls
      }, [title])]);
    }
  }

  function Value() {
    var showValue = slots.default || isDef(value);
    var left = isValueLeft ? 'value-left' : '';
    var adjoinRight = !isLink && !slots['right-icon'];

    if (showValue) {
      return h("div", {
        "class": [bem('value', {
          alone: !showTitle,
          'adjoin-right': adjoinRight
        }), props.valueClass, left]
      }, [slots.default ? slots.default() : h("span", [value])]);
    }
  }

  function LeftIcon() {
    if (slots.icon) {
      return slots.icon();
    }

    if (icon) {
      return h(Icon, {
        "class": bem('left-icon'),
        "attrs": {
          "name": icon,
          "classPrefix": props.iconPrefix
        }
      });
    }
  }

  function bigIconRender() {
    if (bigIcon) {
      return h("div", {
        "class": bem('big-icon')
      }, [h("van-image", {
        "attrs": {
          "width": "100%",
          "height": "100%",
          "radius": "6px",
          "src": bigIcon
        }
      })]);
    }
  }

  function RightIcon() {
    var rightIconSlot = slots['right-icon'];

    if (rightIconSlot) {
      var el = rightIconSlot();

      if (Array.isArray(el) && el.length && el[0].data) {
        el[0].data.class = el[0].data.class || [];
        el[0].data.class = [].concat(el[0].data.class, [bem('right-icon')]);
      }

      return el;
    }

    if (isLink) {
      var arrowDirection = props.arrowDirection;
      return h(Icon, {
        "class": bem('right-icon'),
        "attrs": {
          "name": arrowDirection ? "cap-arrow-" + arrowDirection : 'cap-arrow'
        }
      });
    }
  }

  function onClick(event) {
    emit(ctx, 'click', event);
    functionalRoute(ctx);
  }

  var clickable = isLink || props.clickable;
  var classes = {
    clickable: clickable,
    center: props.center,
    required: props.required,
    borderless: !props.border
  };

  if (size) {
    classes[size] = size;
  }

  return h("div", _mergeJSXProps([{
    "class": bem(classes),
    "attrs": {
      "role": clickable ? 'button' : null,
      "tabindex": clickable ? 0 : null
    },
    "on": {
      "click": onClick
    }
  }, inherit(ctx)]), [bigIconRender(), h("div", {
    "class": [bem('flexrow'), {
      'is-big-icon-row': bigIcon
    }]
  }, [h("div", {
    "class": [bem('flexbox')]
  }, [LeftIcon(), Title(), Value(), RightIcon(), slots.extra == null ? void 0 : slots.extra()]), Label()])]);
}

Cell.props = _extends({}, cellProps, routeProps);
export default createComponent(Cell);